module.exports = __webpack_public_path__ + "static/media/again-large@2x.554975ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/again-large@2x.png
// module id = 913
// module chunks = 0